import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import Landing from "@/pages/Landing";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#0d1620",
              color: "#faf3e8",
              border: "1px solid rgba(232,90,36,0.4)",
              borderRadius: "999px",
              padding: "12px 20px",
              fontFamily: "'Work Sans', sans-serif",
              fontSize: "0.85rem",
              letterSpacing: "0.05em",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
